<template lang="html">
    <div>
        <payment-single-row
            v-for="(group, index) in groupedPaymentsList"
            :isUnsavedRefund="group[0].id < 0"
            :payments="group"
            :refunds="refunds"
            :reservation="reservation"
            :key="group[0].transactionCode || group[0].id || index"
            class="mb-1">
        </payment-single-row>
    </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import paymentSingleRow from './paymentSingleRow'
import PAYMENT_DIRECTION from '@/enums/paymentDirection'

export default {

    props: {
        reservation:{
            type: Object
        },
        payments: {
            type: Array,
            default: function () {
                return []
            }
        },
        refunds: {
            type: Array,
            default: function () {
                return []
            }
        },
    },
    computed: {
        ...mapGetters([
            'getRefundReasons',
            'getPercentageOrCurrency'
        ]),
        groupedPaymentsList() {
            const groups = [];
            const codeMap = new Map();

            for (const payment of this.payments) {
                const isRefund = !!payment.refundId;
                const isUnsaved = payment.id < 0;
                const isPayIn = payment.paymentDirection === PAYMENT_DIRECTION.PAY_IN;

                if (isRefund || isUnsaved || !isPayIn || !payment.transactionCode) {
                    groups.push([payment]);
                } else if (codeMap.has(payment.transactionCode)) {
                    codeMap.get(payment.transactionCode).push(payment);
                } else {
                    const group = [payment];
                    codeMap.set(payment.transactionCode, group);
                    groups.push(group);
                }
            }

            return groups;
        }
    },
    components:{
        paymentSingleRow
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// paymentRows.vue?f1487490